import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Accueil from "./pages/Accueil";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MonCompte from "./pages/MonCompte";
import Scan from "./pages/Scan";
import ProtectedRoute from "./components/ProtectedRoute";
import QuiSommesNous from "./pages/QuiSommesNous";
import Profil from "./pages/Profil";
import Parametres from "./pages/Parametres";
import CookieBanner from "./components/CookieBanner";
import WashBrosSubscribe from "./pages/WashBrosSubscribe";
import Paiement from "./pages/Paiement";
import NosServices from "./pages/NosServices";
import WhoWe from "./pages/WhoWe";
import CafeZamenoulli from "./pages/CafeZamenoulli";
import Footer from "./components/Footer";
import IntroAnimation from "./components/IntroAnimation";
import PageTransition from "./components/PageTransition";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import Links from "./pages/Links";
import PolitiqueCookies from "./pages/PolitiqueCookies";
import WashBrosTeasing from "./pages/WashBrosTeasing";
import ZamenoulliTeasing from "./pages/ZamenoulliTeasing";
// ── Nouvelles pages légales ──
import APropos from "./pages/APropos";
import CGU from "./pages/CGU";
import Confidentialite from "./pages/Confidentialite";

function App() {
  return (
    <Router>
      {/* Animation d'intro au premier chargement du site */}
      <ScrollToTop /> 
      <IntroAnimation />

      <Header />

      <div style={{ paddingTop: "90px" }}>
        <PageTransition>
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
            <Route path="/nos-services" element={<NosServices />} />
            <Route path="/whowe" element={<WhoWe />} />
            <Route path="/cafe-zamenoulli" element={<CafeZamenoulli />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/wash-bros" element={
              <ProtectedRoute><WashBrosSubscribe /></ProtectedRoute>
            } />
            <Route path="/paiement" element={
              <ProtectedRoute><Paiement /></ProtectedRoute>
            } />
            <Route path="/abonnement" element={
              <ProtectedRoute><MonCompte /></ProtectedRoute>
            } />
            <Route path="/profil" element={
              <ProtectedRoute><Profil /></ProtectedRoute>
            } />
            <Route path="/parametres" element={
              <ProtectedRoute><Parametres /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute adminOnly={true}><Admin /></ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
            <Route path="/links" element={<Links />} />
            <Route path="/politique-cookies" element={<PolitiqueCookies />} />
            <Route path="/wash-bros-teasing" element={<WashBrosTeasing />} />
            <Route path="/zamenoulli-teasing" element={<ZamenoulliTeasing />} />
            {/* ── Pages légales ── */}
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
          </Routes>
        </PageTransition>
        <Footer />
      </div>
      <CookieBanner />
    </Router>
  );
}

export default App;